<!-- @veltra/icons generated sha256:3d8ef5659b93dec0 gen:8 source:src/svg/normal/check.svg -->
<script setup lang="ts">
defineOptions({ name: 'Check' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m6.428 10.57 6.764-6.765a.733.733 0 0 1 1.053-.007l.032.032a.736.736 0 0 1-.01 1.056l-7.486 7.486a.493.493 0 0 1-.702.005L1.737 8.035a.765.765 0 0 1 .006-1.08l.012-.013a.74.74 0 0 1 1.058.013z"
    />
  </svg>
</template>
